const _4001 = 4001; // User rejected the request

function getProvider() {
    if ('phantom' in window) {
        const provider = window.phantom?.solana;

        if (provider?.isPhantom) {
            return provider;
        }
    }
    return false;
}

async function connectWallet(provider, { trusted }) {
    try {
        const res = await provider.connect({ onlyIfTrusted: trusted });
        console.log(res.publicKey.toString());
    } catch (err) {
        // "Trusted" attempt also returns 4001 when failed
        if (err.code !== _4001) {
            console.log(err);
        }
        return false;
    }
    return true;
}

function handleConnect(publicKey) {
    localStorage.setItem(PUBLIC_KEY, publicKey);
    const connectBtns = document.querySelectorAll('.connect-wallet');
    connectBtns.forEach(btn => btn.textContent = WALLET_CONNECTED);
}

function handleDisconnect() {
    // Also called before "accountChanged" event if already connected
    localStorage.removeItem(PUBLIC_KEY);
    const connectBtns = document.querySelectorAll('.connect-wallet');
    connectBtns.forEach(btn => btn.textContent = CONNECT_YOUR_WALLET);
}

async function handleAccountChanged(publicKey) {
    if (publicKey) {
        // connect is not called in case of an account change
        handleConnect(publicKey);
    } else {
        // Try to connect switched account if its trusted
        const provider = getProvider();
        // Provider has to be present at this point (checked in #init)
        await connectWallet(provider, { trusted: true });
    }
}

function bindEvents(provider) {
    provider.on("connect", handleConnect);
    provider.on("disconnect", handleDisconnect)
    provider.on('accountChanged', handleAccountChanged);
}

async function init() {
    const provider = getProvider();
    if (provider) {
        bindEvents(provider);
        await connectWallet(provider, { trusted: true });
    }

    const connectBtns = document.querySelectorAll('.connect-wallet');
    connectBtns.forEach(btn => btn.addEventListener('click', async (ev) => {
        ev.preventDefault();
        if (!provider) {
            // todo: replace with a better alternative
            return window.open('https://phantom.app/', '_blank');
        }
        if (!provider.isConnected) {
            await connectWallet(provider, { trusted: false });
        }
    }));
}


export default {
    init,
}
